/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	NAVIGATION_SIDEBAR_SEGMENT_NAME,
	NAVIGATION_SIDEBAR_MARKS,
} from '@jira/navigation-apps__performance-metrics/src/constants.tsx';
import { pageSegmentStore } from '@jira/navigation-apps__performance-metrics/src/index.tsx';

export const setPerformanceMarkLoadStart = (): void => {
	const sideBarSegment = pageSegmentStore.getSegment(NAVIGATION_SIDEBAR_SEGMENT_NAME);
	sideBarSegment.mark(NAVIGATION_SIDEBAR_MARKS.loadStart);
};

export const setPerformanceMarkLoadEnd = (): void => {
	const sideBarSegment = pageSegmentStore.getSegment(NAVIGATION_SIDEBAR_SEGMENT_NAME);
	sideBarSegment.mark(NAVIGATION_SIDEBAR_MARKS.loadEnd);
};
